<div class="slider" tabindex="0" :class="{'slider--mobile': mobile, 'slider--mobile-full': userStore.mobile}">
    <div class="slider__items" v-if="!mobile">
        <span class="slider__items-item" :class="{'active': isActiveFromList(media.id)}" v-for="(media, index) in medias" :key="media.id"></span>
    </div>
    <ul class="slider__list" v-on:keyup="onKeyPress">
        <li v-for="(media, index) in medias" :key="media.id" v-on:touchstart="onTouchStart" v-on:touchend="onTouchEnd" :class="{ 'current': index === currentSelected, 'next': index === currentSelected + 1, 'previous': index === currentSelected - 1 }">
            <div class="slider__item">
                <div class="slider__item-content" v-if="media.type === 'video'">
                    <video ref="mediasRef" controlslist="nodownload noplaybackrate" disablepictureinpicture controls v-if="media.hasOwnProperty('name')">
                        <source :src="videoUrl(getPerformer(media).id, media)" type="video/mp4" />
                    </video>
                    <img v-if="getVideoPlaceholder(media).active" :src="getVideoPlaceholder(media).url" onerror="this.style.display='none'" />
                </div>
                <div class="slider__item-content" v-else>   
                    <img :src="getSliderImages(getPerformer(media).id, media)" />
                </div>
                <div class="slider__item-purchase" v-if="isPaidMedia(media)">
                    <img class="slider__item-purchase-lock" :src="getStaticImages('lock', 'png')" />
                    <button @click="toggleModal()" class="btn btn-small">{{ media.type === 'video' ? $t('profile.unlockvideo') : $t('profile.unlockphoto') }}</button>
                    <h3 class="slider__item-purchase-price">{{ media.price }} {{ $t('profile.credits') }}</h3>
                    <i class="slider__item-purchase-time">{{ media.validPeriod }} {{ $t('profile.days') }}</i>
                    <div v-if="isModal" class="slider__item-purchase-modal">
                        <div v-if="noCredits" class="slider__item-purchase-modal-content">
                            <h3>{{ $t('modals.buy.noCreditsTitle') }}</h3>
                            <router-link :to="{name:'payment'}"><button class="btn btn-full">{{ $t('modals.buy.upgrade') }}</button></router-link>
                            <button @click="toggleModal()" class="btn btn-bordered btn-black btn-full">{{ $t('modals.buy.cancel') }}</button>
                        </div>
                        <div v-else class="slider__item-purchase-modal-content">
                            <h3>{{ $t('modals.buy.title') }}</h3>
                            <button @click="buyContent(media)" class="btn btn-full">{{ $t(media.type === 'video' ? 'modals.buy.video' : 'modals.buy.photo') }}</button>
                            <button @click="toggleModal()" class="btn btn-bordered btn-black btn-full">{{ $t('modals.buy.cancel') }}</button>
                        </div>
                    </div>
                </div>

                <div class="slider__item-description" v-if="media.description">
                    <p>{{ media.description }}</p>
                </div>
            </div>
        </li>
        <li v-if="!hasMedia" class="current">
            <div class="slider__item">
                <div class="slider__item-img">
                    <img :src="getAvatar(getPerformer(), 'medium')" />
                </div>
            </div>
        </li>
    </ul>
    <div class="slider__left" v-if="hasMedia && !isFirst"><button v-on:click="previous"></button></div>
    <div class="slider__right" v-if="hasMedia && !isLast"><button v-on:click="next"></button></div>
    <div class="slider__close" v-on:click="close"></div>
</div>